/** Default dashboard layout — matches current production dashboard. */
export const DEFAULT_DASHBOARD_CONFIG = {
  version: 1,
  overviewCards: {
    enabled: ['bills', 'sales', 'customers', 'pending', 'lowStock', 'expenses'],
    maxVisible: 8,
  },
  quickActions: {
    enabled: true,
    slots: [
      { id: 'new_sale', key: 'F1', visible: true },
      { id: 'purchase', key: 'F2', visible: true },
      { id: 'add_product', key: 'F3', visible: true },
      { id: 'stock_check', key: 'F4', visible: true },
      { id: 'customer_dues', key: 'F5', visible: true },
      { id: 'sales_report', key: 'F6', visible: true },
      { id: 'invoice_pnl', key: 'F7', visible: true },
      { id: 'day_close', key: 'F8', visible: true },
      { id: 'pos_settings', key: 'F9', visible: true },
    ],
  },
  sections: [
    { id: 'overview', visible: true, columns: 12 },
    { id: 'quick_actions', visible: true, columns: 12 },
    { id: 'alerts', visible: true, columns: 5 },
    { id: 'sales_overview', visible: true, columns: 7 },
    { id: 'inventory_health', visible: true, columns: 4 },
    { id: 'low_stock', visible: true, columns: 4 },
    { id: 'best_sellers', visible: true, columns: 4 },
    { id: 'pending_payments', visible: true, columns: 6 },
    { id: 'recent_activity', visible: true, columns: 6 },
  ],
  salesChart: { template: 'template1' },
  lowStock: { includeOutOfStock: true },
  alerts: {
    lowStock: true,
    outOfStock: true,
    creditDue: true,
    subscription: true,
  },
};

export const OVERVIEW_CARD_IDS = [
  'bills',
  'sales',
  'customers',
  'pending',
  'lowStock',
  'expenses',
  'suppliers',
  'profit',
  'creditCustomers',
];

export const SECTION_IDS = DEFAULT_DASHBOARD_CONFIG.sections.map((s) => s.id);
